<!-- Image rendering when not editable -->
<img (click)="toggleModal()" 
  *ngIf="!enableChange && !listtype"
  [@inbgOutAnimation]
  [ngClass]="[logosize, showSpinner ? 'blur-img' : '', 'shadow', 'img-fluid']"
  [src]="personimageurl"
  (error)="refreshUrl(personId)"
  alt="Person image" />

<!-- Smaller image for list view -->
<img (click)="toggleModal()" 
  *ngIf="!enableChange && listtype"
  [@inbgOutAnimation]
  width="30"
  height="30"
  class="rounded-circle"
  [src]="personimageurl"
  (error)="refreshUrl(personId)"
  alt="Person image (list)" />

<!-- Modal for changing image -->
<div *ngIf="enableChange" class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ 'personimage.header' | trans }}</h4>
      <button (click)="toggleModal()" type="button" class="close" data-dismiss="modal" aria-label="Close">
        &times;
      </button>
    </div>

    <div class="modal-body">
      <div *ngIf="showSucces" class="alert alert-success" role="alert">
        {{ 'personimage.successmsg' | trans }}
      </div>

      <div *ngIf="!showSucces">
        <div class="custom-file">
          <input
            type="file"
            (change)="fileChangeEvent($event)"
            class="custom-file-input"
            id="validatedCustomFile"
            required />
          <label class="custom-file-label" for="validatedCustomFile">
            {{ selectedFiles ? selectedFileName : ('personimage.choosefile' | trans) }}
          </label>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col text-center border-right">
          <p *ngIf="cropperready" class="text-muted pb-0 mb-0 pt-2">
            {{ 'personimage.croptofit' | trans }}
          </p>
          <div class="pl-3 pt-1" style="width: 200px; height: 200px;">
            <image-cropper
              [imageChangedEvent]="imageChangedEvent"
              [maintainAspectRatio]="true"
              [aspectRatio]="1 / 1"
              format="webp"
              [resizeToWidth]="250"
              (imageCropped)="imageCropped($event)"
              (cropperReady)="cropperReady()"
              (loadImageFailed)="loadImageFailed()">
            </image-cropper>
          </div>
        </div>

        <div *ngIf="cropperready" class="col text-center">
          <p class="text-muted pb-0 mb-0 pt-2">{{ 'personimage.croppreview' | trans }}</p>
          <img class="p-1 pt-2 pb-2 img-thumbnail-big" [src]="croppedImage" width="185" height="185" />
        </div>
      </div>

      <div class="row mt-3">
        <div class="col">
          <button (click)="toggleModal()" data-dismiss="modal" type="button" class="btn-close float-left">
            <h6 class="btn-save-text">{{ 'personimage.close' | trans }}</h6>
          </button>
        </div>
        <div class="col" *ngIf="cropperready && !showSucces">
          <button (click)="onDocumentSubmit()" type="button" class="btn-save float-right">
            <h6 class="btn-save-text">{{ 'personimage.save' | trans }}</h6>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>